import React from "react";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import BaseHeader from "./BaseView/BaseHeader";
import BaseFooter from "./BaseView/BaseFooter";
import Parallax from "../components/Parallax/Parallax";
import DashboardIcon from "@material-ui/core/SvgIcon/SvgIcon";
import EmptyCard from "./components/EmptyCard";
import LoadingCard from "./components/LoadingCard";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {withStyles} from "@material-ui/core";
import blogPostPageStyle from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";

import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

import CheckIcon from '@material-ui/icons/Check';

import Paper from '@material-ui/core/Paper';
import {allTagInVideo, allVideos, getVideoAllTags} from "../utils/request";
import SeriesItem from "./components/SeriesItem";
import Badge from "../components/Badge/Badge";
import SeriesVideoTags2 from "./components/VideoTages2";
import intl from "react-intl-universal";


function createData(id, title, difficult, learn, collect, play, videoId) {
	let diffColor = 'success';
	switch (difficult) {
		case "易":
			diffColor = 'success';
			break;
		case "中":
			diffColor = 'warning';
			break;
		case "难":
			diffColor = 'danger';
			break;
		default:
			diffColor = 'success';
	}
	return {id, title, difficult, learn, collect, play, diffColor, videoId};
}


const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);


class Video extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			tableRows: [],
			allTags: [],
			videos: [],
		};
		this.initData()
	}

	initData = () => {
		getVideoAllTags().then(res => {
			this.setState({
				allTags: res.data
			})
		});
		allVideos().then(res => {
			this.setState({
				videos: res.data,
				showVideos: res.data,
			}, () => {

				const _rows = [];

				this.state.videos.map(data => {
					const row = createData(data.showId, data.title, data.hard, data.learn, data.collect, data.play, data.id);
					_rows.push(row)
				});

				this.setState({
					tableRows: _rows
				})
			})
		})
	};

	toVideo = (id) => {
		const w = window.open('about:blank');
		w.location.href = '/mockingbird/' + id;
	};


	inInTag = (id, ids) => {
		for (const tagId of ids) {
			if (id === tagId) {
				return true
			}
		}
		return false
	};

	itemChange(text) {
		if (text === 'ALL') {
			const _rows = [];
			this.state.videos.map(data => {
				const row = createData(data.showId, data.title, data.hard, data.learn, data.collect, data.play, data.id);
				_rows.push(row)
			});
			this.setState({
				tableRows: _rows
			})
		} else {
			this.setState({
				tableRows: []
			}, () => {

				allTagInVideo(text).then(res => {
					const tagData = res.data;

					const _showVideo = [];

					this.state.videos.map(data => {
						// console.log(res.data)
						if (this.inInTag(data.id, tagData)) {
							const row = createData(data.showId, data.title, data.hard, data.learn, data.collect, data.play, data.id);
							_showVideo.push(row)
						}
					})

					this.setState({
						tableRows: _showVideo,
					});
				})
			})
		}
	}

	render() {
		const {classes} = this.props;

		return (
			<div>

				<BaseHeader fixed/>

				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/video_bg.jpg"}
						  filter="dark" small>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={10} className={classes.textCenter}>
								<h1 className={classes.title} style={{color: "white"}}>
									{intl.get('video_list')}
								</h1>
							</GridItem>
							<GridItem xs={12} sm={12} md={10} className={classes.textCenter}>
								<h4 className={classes.title} style={{color: "white"}}>
									{intl.get('video_list_info')}
								</h4>
							</GridItem>
						</GridContainer>
					</div>
				</Parallax>

				<div className={classes.main}>
					<div className={classes.container}>
						<GridContainer style={{paddingTop: '32px'}}>
							<GridItem
								xs={12}
								sm={12}
								md={12}
								className={classes.mlAuto + " " + classes.mrAuto}
								style={{marginBottom: '12px'}}
							>
								<SeriesVideoTags2 data={this.state.allTags}
												  onChangeItem={this.itemChange.bind(this)}/>
							</GridItem>

							<GridItem
								xs={12}
								sm={12}
								md={12}
								className={classes.mlAuto + " " + classes.mrAuto}
							>
								<TableContainer component={Paper}>
									<Table className={classes.table}
										// size="small"
										//    stickyHeader
										//    aria-label="video"
									>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell
													alihn="left">Id</StyledTableCell>
												<StyledTableCell
													align="left">{intl.get('subject')}</StyledTableCell>
												<StyledTableCell
													align="center">{intl.get('difficultly')}</StyledTableCell>
												<StyledTableCell
													align="center">{intl.get('learned')}</StyledTableCell>
												<StyledTableCell
													align="center">{intl.get('collected')}</StyledTableCell>
												<StyledTableCell
													align="center">{intl.get('can_play')}</StyledTableCell>
											</StyledTableRow>
										</TableHead>


										<TableBody>
											{this.state.tableRows.map((row) => (

												<StyledTableRow key={row.id}
																onClick={this.toVideo.bind(this, row.videoId)}
												>
													<StyledTableCell
														align="left">{row.id}</StyledTableCell>
													<StyledTableCell component="th"
																	 scope="row">
														{row.title}
													</StyledTableCell>
													<StyledTableCell
														align="center">
														<Badge
															color={row.diffColor}
														><b style={{fontSize: 14}}>{row.difficult}</b></Badge></StyledTableCell>
													<StyledTableCell
														align="center">
														{row.learn ?
															<Badge
																color="info"><CheckIcon
																style={{fontSize: 14}}/>
															</Badge>
															:
															null}
													</StyledTableCell>
													<StyledTableCell
														align="center">
														{row.collect ?
															<Badge
																color="primary"><CheckIcon
																style={{fontSize: 14}}/>
															</Badge>
															:
															null}
													</StyledTableCell>
													<StyledTableCell
														align="center">
														{row.play ?
															<Badge
																color="rose"><CheckIcon
																style={{fontSize: 14}}/>
															</Badge>
															:
															null}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>


									</Table>
								</TableContainer>

								{
									this.state.tableRows.length < 1 ?
										<LoadingCard type={2}/>
										:
										null
								}
							</GridItem>
						</GridContainer>
					</div>
				</div>

				<BaseFooter/>
			</div>
		);
	}
}

export default withStyles(blogPostPageStyle)(Video)